const BREAKPOINT = 993;
const BODY_OFFSET = 10; // matches `.block-body` translateX(10px) in hero.scss

function syncHeroWidth() {
    const source = document.querySelector('.js-get-width');
    const target = document.querySelector('.js-set-width');

    if (!source || !target) return;

    if (window.innerWidth >= BREAKPOINT) {
        const grid = source.closest('.block-grid');
        if (!grid) return;
        const firstColWidth = parseFloat(getComputedStyle(grid).gridTemplateColumns.split(' ')[0]);
        target.style.width = (firstColWidth + BODY_OFFSET) + 'px';
    } else {
        target.style.width = '';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(syncHeroWidth);
});
window.addEventListener('load', syncHeroWidth);
window.addEventListener('resize', syncHeroWidth);
